import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosConfig from '../../utils/axiosConfig';

const ADMIN_DASHBOARD_API = '/admin/dashboard';

export const getAdminDashboardTimeseries = createAsyncThunk(
	'adminDashboard/timeseries',
	async (months = 6, { rejectWithValue }) => {
		try {
			const response = await axiosConfig.post(
				`${ADMIN_DASHBOARD_API}/timeseries`,
				{ months },
				{ withCredentials: false },
			);
			return response.data;
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);

export const getAdminDashboardSummary = createAsyncThunk(
	'adminDashboard/summary',
	async (_, { rejectWithValue }) => {
		try {
			const response = await axiosConfig.post(`${ADMIN_DASHBOARD_API}/summary`, {}, {
				withCredentials: false,
			});
			return response.data;
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);
